import axios from 'axios'

const sendVirtualEventDataUpdate = (eventId, data, host = '') => {

    const getAssets = (data) => {
        const assets: any[] = []
        if (data.keyword) {
            assets.push({ type: "keyword", value: data.keyword })
        }
        if (data.primarySubCommunity) {
            assets.push({ type: "primarySubCommunity", value: data.primarySubCommunity })
        }
        if (data.secondarySubCommunity) {
            assets.push({ type: "secondarySubCommunity", value: data.secondarySubCommunity })
        }
        if (data.primaryColor) {
            assets.push({ type: "primaryColor", value: data.primaryColor })
        }
        if (data.secondaryColor) {
            assets.push({ type: "secondaryColor", value: data.secondaryColor })
        }
        if (data.accentColor) {
            assets.push({ type: "accentColor", value: data.accentColor })
        }

        return assets
    }

    const formData: any = {
        accountId: data.accountId,
        accountName: data.accountName,
        title: data.title,
        description: data.description,
        type: data.type && data.type.toLowerCase() === 'brighttalk originals' ? 'BrightTALK Originals' : data.type,
        onPortal: data.onPortal,
        timezone: data.timezone,
        scheduledStartDate: data.scheduledStartDate,
        scheduledEndDate: data.scheduledEndDate,
        published: data.published,
        assets: getAssets(data),
        visibility: data.visibility
    }

    if (data && data.favicon) {
        formData.faviconLink = data.favicon
    }

    if (data && data.companyLogo) {
        formData.companyLogo = data.companyLogo
    }

    if (data && data.heroImage) {
        formData.heroImage = data.heroImage
    }

    if (data && data.socialMediaLogo) {
        formData.socialMediaLogo = data.socialMediaLogo
    }

    if (data.imageUrl) {
        formData.imageUrl = data.imageUrl
    }

    if (data.customUrl) {
        formData.customUrl = data.customUrl
    }

    if (data.faviconLink) {
        formData.faviconLink = data.faviconLink
    }

    if (data.type.toLowerCase() !== 'virtual event+' && data.featured) {    
        formData.featured = data.featured
    }

    if (data.type.toLowerCase() !== 'virtual event+' && data.parentCommunity) {
        formData.community = data.parentCommunity || ''
    }

    if (data.featuredCom) {
        formData.featuredCom = data.featuredCom
    }

    if (data.episodeSort) {
        formData.episode = {
            order: data.episodeSort
        }
    }

    return axios.put(`${host}/service/summit/v3/summit/${eventId}`, formData,
        {
            headers: {
                'content-type': 'application/json',
                'accept': 'application/json',
                'BrightTALK-API-Client': 'brighttalk-central',
                withCredentials: true
            }
        }
    )

}

export default sendVirtualEventDataUpdate
